export default "__VITE_ASSET__Blj4PzZe__"